import { removeKeysMatching } from "@omni/utils/object.utils";
import queryString from "query-string";

import { SearchConfiguration } from "@/redux/modules/value/search/search.types";
import { configurationToRoute } from "@/utils/search/routing/configurationToUrl/configurationToRoute";
import { PREFIX_SEPARATOR } from "@/utils/search/routing/routing.configuration";
import {
    GroupToPrefixMap,
    Route
} from "@/utils/search/routing/types/route.types";

const createUrl = (route: Route) => {
    const { query, url } = queryString.parseUrl(location.href);
    const newParams = removeKeysMatching(query, (key) =>
        Object.values(GroupToPrefixMap).some((prefix) =>
            key.startsWith(`${prefix}${PREFIX_SEPARATOR}`)
        )
    );
    return queryString
        .stringifyUrl({
            url,
            query: {
                ...newParams,
                ...route
            }
        })
        .replaceAll("%20", "+")
        .replaceAll("%2B", "+");
};

const getDocumentTitle = () => {
    const title = document.head
        .querySelector("[property$=title][content]")
        ?.getAttribute("content");

    return title ?? document.title;
};

const updateWindowTitleByConfiguration = (
    configuration?: SearchConfiguration
) => {
    const query = configuration?.query;
    const currentTitle = getDocumentTitle();

    document.title = query ? `${query} | ${currentTitle}` : currentTitle;
};

const configurationToUrl = (
    configuration: SearchConfiguration,
    ignoreQuery: boolean
): string => {
    const route = configurationToRoute(configuration, ignoreQuery);
    return createUrl(route);
};

export { configurationToUrl, updateWindowTitleByConfiguration };
